
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Badge } from 'antd'
import { createUseStyles, useTheme } from 'react-jss'

const useStyles = createUseStyles({
  badge: {
    marginLeft: 10,
  },
  title: {},
})

export default function MenuLink({
  route,
  title,
  icon = undefined,
  theme = 'outlined',
  badgeCount = undefined,
  color = '',
}) {
  const classes = useStyles()
  const { brandPrimary } = useTheme()
  const col = color || brandPrimary
  const Icon = icon

  return (
    <Link to={route}>
      {icon && <Icon theme={theme} style={{ fontSize: 18, color: col }} />}
      <span style={{ color: col }}>{title}</span>
      {Boolean(badgeCount) && (
        <Badge count={badgeCount} className={classes.badge} />
      )}
    </Link>
  )
}

MenuLink.propTypes = {
  route: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.oneOf([PropTypes.func, PropTypes.undefined]),
  badgeCount: PropTypes.number,
  theme: PropTypes.string,
  color: PropTypes.string,
}
